export const getLocalStorage = (key) => {
  const localStorageJson = typeof window !== 'undefined' ? window.localStorage.getItem(key) : {}
  return typeof localStorageJson === 'string' ? JSON.parse(localStorageJson) : localStorageJson
}

export const setLocalStorage = (key, value) => {
  return typeof window !== 'undefined' ? window.localStorage.setItem(key, JSON.stringify(value)) : {}
}

export const removeLocalStorage = (key) => {
  return typeof window !== 'undefined' ? window.localStorage.removeItem(key) : {}
}
